export default __webpack_public_path__ + "static/social-6bbb95e486900d1962f932f07da5cde0.jpg";